<script lang="ts">
	import DOMPurify from "isomorphic-dompurify";

	interface Props {
		content: string;
	}

	let { content }: Props = $props();
</script>

<div class="html-content-viewer">
	<!-- eslint-disable-next-line svelte/no-at-html-tags -->
	{@html DOMPurify.sanitize(content)}
</div>

<style>
	:global(.html-content-viewer a) {
		text-decoration: underline;
		color: var(--color-blue-600);
	}
	:global(.html-content-viewer p:empty::after) {
		content: "\00A0";
	}
</style>
